import React, { useEffect, useState, useRef, useContext } from "react";
import "./RamlCircle.css";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { ramlKey } from "../../data";
import RamlCircle2 from "./RamlCircle2";
import { MainContext } from "../../contexts/MainContext";
import apiUrl from "../../utils/ApiConfig";
import ApiGetX2 from "../../utils/ApiServicesX/ApiGetX2";
import { useLocation } from "react-router-dom";

export default function RamlCircle1() {
  let { userId, lotNameCon, titleIdCon, questionIdCon, setZayech, zayech, zayechB, setValue16, imageRef, setZayechB, zayechC, setZayechC, setSecondSelectDisabled } =
    useContext(MainContext);
  const location = useLocation();

  // const [ramlKeys, setRamlKeys] = useState(ramlKey);
  const mainContext = useContext(MainContext);

  // const [localData2, setlocalData2] = useState(() => {
  //   let y = JSON.parse(localStorage.getItem("mainObj2"));
  //   if (y) {
  //     return y;
  //   } else {
  //     return "";
  //   }
  // });
  // const [localData, setlocalData] = useState(() => {
  //   let x = JSON.parse(localStorage.getItem("mainObject"));
  //   if (x) {
  //     return x;
  //   } else {
  //     return "";
  //   }
  // });
  // const [filterItem1, setFilteritem1] = useState(
  //   ramlKeys.filter((items) => {
  //     return items.keynum == localData.raml1;
  //   })
  // );

  // const [filterItem2, setFilteritem2] = useState(
  //   ramlKeys.filter((items) => {
  //     return items.keynum == localData.raml2;
  //   })
  // );
  // const [filterItem3, setFilteritem3] = useState(
  //   ramlKeys.filter((items) => {
  //     return items.keynum == localData.raml3;
  //   })
  // );
  // const [filterItem4, setFilteritem4] = useState(
  //   ramlKeys.filter((items) => {
  //     return items.keynum == localData.raml4;
  //   })
  // );

  // const [val, setVal] = useState(() => {
  //   if (filterItem1.length !== 0 && filterItem2.length !== 0 && filterItem3.length !== 0 && filterItem4.length !== 0) {
  //     return "" + filterItem1[0].keyA + "" + filterItem2[0].keyA + "" + filterItem3[0].keyA + "" + filterItem4[0].keyA + "";
  //   }
  // });
  // const [value, setValue] = useState({ Value: val });
  // const [allShaps, setAllShaps] = useState([]);

  //////////////////////////////////////

  // const getShapes = (code4) => {
  //   let obj = {
  //     id: 0,
  //     shapeValue: "string",
  //     lotName: lotNameCon ? lotNameCon : null,
  //     titleID: titleIdCon ? titleIdCon : null,
  //     agQuestionId: questionIdCon ? questionIdCon : null,
  //     userId: userId,
  //   };
  //   async function myApp() {
  //     const res = await fetch(`${apiUrl}/MainCal2?Value=${code4}`, {
  //       method: "POST",
  //       credentials: "include",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(obj),
  //     })
  //       .then((res) => {
  //         console.log(res);
  //         if (res.ok)
  //           res.json().then((result) => {
  //             setAllShaps(result.result);
  //             setZayech(result.result);
  //           });
  //       })
  //       .catch((err) => console.log(err));
  //   }
  //   myApp();
  // };
  // const getValue16Code = (obj) => {
  //   async function myApp() {
  //     const res = await fetch(`${apiUrl}/MainCal`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(obj),
  //     }).then((res) => {
  //       if (res.ok) {
  //         return res.json().then((result) => {
  //           setValue16(result.value);
  //         });
  //       }
  //     });
  //   }
  //   myApp();
  // };

  // useEffect(() => {
  //   if (localData2) {
  //     getShapes(localData2.Value);
  //     getValue16Code(localData2);
  //   } else {
  //     getShapes(value.Value);
  //     getValue16Code(value);
  //   }
  // }, []);

  useEffect(() => {
    setZayechB([]);
    setZayechC([]);
    setSecondSelectDisabled(true);
  }, [location]);

  return (
    <>
      <Container>
        <Row>
          <Col xs={11} md={12}>
            <div>
              <>
                <div>
                  {zayech?.length == 0 ? (
                    <>
                      <div className="ramlcircle-loading ">
                        <div class="loading">
                          <div class="loading_circle"></div>
                          <div class="loading_circle"></div>
                          <div class="loading_circle"></div>
                        </div>
                        <h1 className="ramlcircle-div2">درحال لود شدن</h1>
                      </div>
                    </>
                  ) : (
                    <div className="diva">
                      <div>
                        <>
                          {zayech.length != 0 && (
                            <Col className="div1">
                              <img ref={imageRef} id="circleImage" src="./images/pagePishrafte/dayere4.png" style={{ width: "100%" }} alt="" />
                              {zayech?.map((item, index) => (
                                <>
                                  <span key={index} className={`span${index + 1}`}>
                                    <div className="ramlcircle-divapi">
                                      <img className="ramlcircle-imgapi" src={item.src} alt="" />
                                    </div>
                                  </span>
                                </>
                              ))}
                              {zayechB?.length !== 0 &&
                                mainContext.flag !== false &&
                                zayechB?.map((item, index) => (
                                  <>
                                    <span ref={mainContext.imageSpan1} key={index} className={`span${index + 1}-${1}`}>
                                      <div className="ramlcircle-divapi">
                                        <img className="ramlcircle-imgapi" src={item.src} alt="" />
                                      </div>
                                    </span>
                                  </>
                                ))}{" "}
                              {zayechC?.length != 0 &&
                                mainContext.flag !== false &&
                                zayechC.map((item, index) => (
                                  <>
                                    <span ref={mainContext.imageSpan1} key={index} className={`span${index + 1}-${2}`}>
                                      <div className="ramlcircle-divapi">
                                        <img className="ramlcircle-imgapi" src={item.src} alt="" />
                                      </div>
                                    </span>
                                  </>
                                ))}
                            </Col>
                          )}
                        </>
                      </div>
                    </div>
                  )}
                </div>
              </>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
